import { render } from "./EditorMenuItem.vue?vue&type=template&id=55887fa5&ts=true"
import script from "./EditorMenuItem.vue?vue&type=script&lang=ts"
export * from "./EditorMenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__